import { Box } from "@mui/material";
import { motion } from "motion/react";

export default function SectionReveal({ children, delay = 0, sx = {} }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.18 }}
      transition={{ duration: 0.65, delay }}
    >
      <Box sx={sx}>{children}</Box>
    </motion.div>
  );
}